import React, { useEffect } from "react";

import { Error } from "react-admin";
import { logError } from "../utils/appUtils";

//  in src/MyLayout.js
// import { Layout } from 'react-admin';
// import DefaultError from './DefaultError';
// const MyLayout = (props) => <Layout {...props} error={DefaultError} />;

const DefaultError = (props) => {
  const { error, errorInfo } = props;

  useEffect(() => {
    debugger;
    logError(error.toString(), errorInfo.componentStack, false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Error {...props} />;
};

export default DefaultError;
